export const NOOP = (): any => {
  // nada
};
